const AUTH_REDIRECT_BASE = "https://feedvote.local";
const AUTH_ROUTES = new Set(["/signin", "/signup"]);

export function getSafeInternalRedirect(
  value: string | null | undefined,
  fallback = "/dashboard",
): string {
  const candidate = value?.trim();
  if (!candidate || !candidate.startsWith("/") || candidate.startsWith("//")) {
    return fallback;
  }

  try {
    const url = new URL(candidate, AUTH_REDIRECT_BASE);
    if (url.origin !== AUTH_REDIRECT_BASE || AUTH_ROUTES.has(url.pathname)) {
      return fallback;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}
